import { Link } from 'react-router-dom';

/** SCO-69 — About / Legal: the affiliation disclaimer in full. */
export function About() {
  return (
    <div className="legal-page">
      <p className="muted small">
        <Link to="/">← Back</Link>
      </p>
      <h1>About DenLodge</h1>
      <p>
        DenLodge is an independent web app for running a Cub Scout pack — dues, meeting
        planning, advancement tracking, and parent communication. It is built and operated
        by Merganser LLC.
      </p>

      <h2>Not affiliated with Scouting America</h2>
      <p>
        DenLodge is <strong>not affiliated with, endorsed by, or sponsored by</strong> Scouting
        America (formerly the Boy Scouts of America), any local council, or any other Scouting
        organization.
      </p>
      <p>
        “Scouting America”, “Boy Scouts of America”, “Cub Scouts”, “Lion”, “Tiger”, “Wolf”,
        “Bear”, “Webelos”, “Arrow of Light”, and related names, marks, and insignia are
        trademarks or service marks of Scouting America. They are used here only nominatively —
        to describe the program this tool is designed to support. No trademark claim,
        affiliation, or endorsement is implied.
      </p>
      <p>
        Adventure and rank requirement content shown in the app originates from published
        Scouting America materials and is reproduced with attribution for non-commercial
        Scouting use. See the{' '}
        <Link to="/attributions">open-source attributions</Link> page for data sources and
        licensing.
      </p>
    </div>
  );
}
